export const russianCitiesRU = [
  {
    "label": "Майкоп",
    "post_code": "385000"
  },
  {
    "label": "Горно-Алтайск",
    "post_code": "649000"
  },
  {
    "label": "Уфа",
    "post_code": "450000"
  },
  {
    "label": "Улан-Удэ",
    "post_code": "670000"
  },
  {
    "label": "Махачкала",
    "post_code": "367000"
  },
  {
    "label": "Магас",
    "post_code": "386000"
  },
  {
    "label": "Нальчик",
    "post_code": "360000"
  },
  {
    "label": "Элиста",
    "post_code": "358000"
  },
  {
    "label": "Черкесск",
    "post_code": "369000"
  },
  {
    "label": "Петрозаводск",
    "post_code": "185000"
  },
  {
    "label": "Сыктывкар",
    "post_code": "167000"
  },
  {
    "label": "Йошкар-Ола",
    "post_code": "424000"
  },
  {
    "label": "Саранск",
    "post_code": "430000"
  },
  {
    "label": "Якутск",
    "post_code": "677000"
  },
  {
    "label": "Владикавказ",
    "post_code": "362000"
  },
  {
    "label": "Казань",
    "post_code": "420000"
  },
  {
    "label": "Кызыл",
    "post_code": "667000"
  },
  {
    "label": "Ижевск",
    "post_code": "426000"
  },
  {
    "label": "Абакан",
    "post_code": "655000"
  },
  {
    "label": "Грозный",
    "post_code": "364000"
  },
  {
    "label": "Чебоксары",
    "post_code": "428000"
  },
  {
    "label": "Барнаул",
    "post_code": "656000"
  },
  {
    "label": "Краснодар",
    "post_code": "350000"
  },
  {
    "label": "Красноярск",
    "post_code": "660000"
  },
  {
    "label": "Владивосток",
    "post_code": "690000"
  },
  {
    "label": "Ставрополь",
    "post_code": "355000"
  },
  {
    "label": "Хабаровск",
    "post_code": "680000"
  },
  {
    "label": "Благовещенск",
    "post_code": "675000"
  },
  {
    "label": "Архангельск",
    "post_code": "163000"
  },
  {
    "label": "Астрахань",
    "post_code": "414000"
  },
  {
    "label": "Белгород",
    "post_code": "308000"
  },
  {
    "label": "Брянск",
    "post_code": "241000"
  },
  {
    "label": "Владимир",
    "post_code": "600000"
  },
  {
    "label": "Волгоград",
    "post_code": "400000"
  },
  {
    "label": "Вологда",
    "post_code": "160000"
  },
  {
    "label": "Воронеж",
    "post_code": "394000"
  },
  {
    "label": "Иваново",
    "post_code": "153000"
  },
  {
    "label": "Иркутск",
    "post_code": "664000"
  },
  {
    "label": "Калининград",
    "post_code": "236001"
  },
  {
    "label": "Калуга",
    "post_code": "248000"
  },
  {
    "label": "Петропавловск-Камчатский",
    "post_code": "683000"
  },
  {
    "label": "Кемерово",
    "post_code": "650000"
  },
  {
    "label": "Киров",
    "post_code": "610000"
  },
  {
    "label": "Кострома",
    "post_code": "156000"
  },
  {
    "label": "Курган",
    "post_code": "640000"
  },
  {
    "label": "Курск",
    "post_code": "305000"
  },
  {
    "label": "Санкт-Петербург",
    "post_code": "190000"
  },
  {
    "label": "Липецк",
    "post_code": "398000"
  },
  {
    "label": "Магадан",
    "post_code": "685000"
  },
  {
    "label": "Москва",
    "post_code": "101000"
  },
  {
    "label": "Мурманск",
    "post_code": "183000"
  },
  {
    "label": "Нижний Новгород",
    "post_code": "603000"
  },
  {
    "label": "Великий-Новгород",
    "post_code": "173000"
  },
  {
    "label": "Новосибирск",
    "post_code": "630000"
  },
  {
    "label": "Омск",
    "post_code": "644000"
  },
  {
    "label": "Оренбург",
    "post_code": "460000"
  },
  {
    "label": "Орел",
    "post_code": "302000"
  },
  {
    "label": "Пенза",
    "post_code": "440000"
  },
  {
    "label": "Пермь",
    "post_code": "614000"
  },
  {
    "label": "Псков",
    "post_code": "180000"
  },
  {
    "label": "Ростов-на-Дону",
    "post_code": "344000"
  },
  {
    "label": "Рязань",
    "post_code": "390000"
  },
  {
    "label": "Самара",
    "post_code": "443000"
  },
  {
    "label": "Саратов",
    "post_code": "410000"
  },
  {
    "label": "Южно-Сахалинск",
    "post_code": "693000"
  },
  {
    "label": "Екатеринбург",
    "post_code": "620000"
  },
  {
    "label": "Смоленск",
    "post_code": "214000"
  },
  {
    "label": "Тамбов",
    "post_code": "392000"
  },
  {
    "label": "Тверь",
    "post_code": "170000"
  },
  {
    "label": "Томск",
    "post_code": "634000"
  },
  {
    "label": "Тула",
    "post_code": "300000"
  },
  {
    "label": "Тюмень",
    "post_code": "625000"
  },
  {
    "label": "Ульяновск",
    "post_code": "432000"
  },
  {
    "label": "Челябинск",
    "post_code": "454000"
  },
  {
    "label": "Чита",
    "post_code": "672000"
  },
  {
    "label": "Ярославль",
    "post_code": "150000"
  },
  {
    "label": "Обнинск",
    "post_code": "249030"
  }
];